<template>
  <div class="audit-auth-owner-container">
    <!-- (1) PageHeader -->
    <ds-page-header :title="$t('auditAuthOwner.page.title')" :subtitle="$t('auditAuthOwner.page.subtitle')" />

    <el-row :gutter="16">
      <!-- 左侧状态筛选树 -->
      <el-col :xs="24" :sm="24" :md="6" :lg="4">
        <div class="ds-panel ds-status-tree">
          <div class="ds-status-tree__title">{{ $t('auditAuthOwner.page.statusFilter') }}</div>
          <ul class="ds-status-tree__list">
            <li v-for="(item, index) in auditAuthOwnerInfo.states" :key="index" @click="_swatchState(item)"
              :class="{ 'is-active': auditAuthOwnerInfo.conditions.state == item.statusCd }"
              class="ds-status-tree__item">
              {{ item.name }}
            </li>
          </ul>
        </div>
      </el-col>

      <el-col :xs="24" :sm="24" :md="18" :lg="20">
        <!-- (2) SearchPanel -->
        <ds-search-panel>
          <el-row :gutter="16">
            <el-col :xs="24" :sm="12" :md="8" :lg="8">
              <el-input v-model.trim="auditAuthOwnerInfo.conditions.appUserName"
                :placeholder="$t('auditAuthOwner.appUserNamePlaceholder')" clearable
                @keyup.enter.native="_queryAuditAuthOwnerMethod" />
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="8">
              <el-input v-model.trim="auditAuthOwnerInfo.conditions.idCard"
                :placeholder="$t('auditAuthOwner.idCardPlaceholder')" clearable
                @keyup.enter.native="_queryAuditAuthOwnerMethod" />
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="8">
              <el-input v-model.trim="auditAuthOwnerInfo.conditions.link"
                :placeholder="$t('auditAuthOwner.linkPlaceholder')" clearable
                @keyup.enter.native="_queryAuditAuthOwnerMethod" />
            </el-col>
          </el-row>

          <template #actions>
            <el-button type="primary" icon="el-icon-search" @click="_queryAuditAuthOwnerMethod">
              {{ $t('common.search') }}
            </el-button>
            <el-button icon="el-icon-refresh-left" @click="_resetAuditAuthOwnerMethod">
              {{ $t('common.reset') }}
            </el-button>
          </template>
        </ds-search-panel>

        <!-- (3)(4)(6) Toolbar + DataTable + PaginationBar -->
        <div class="ds-panel">
          <ds-toolbar :total="auditAuthOwnerInfo.total" :density="density" :show-column-setting="false"
            :show-refresh="true" @update:density="density = $event" @refresh="_listAuditAuthOwners">
            <template #left>
              <span class="ds-panel__title">{{ $t('auditAuthOwner.authTitle') }}</span>
            </template>
          </ds-toolbar>

          <ds-data-table :data="auditAuthOwnerInfo.appUsers" :loading="loading" :error="hasError"
            :error-message="errorMessage" :density="density" border
            :empty-description="$t('auditAuthOwner.page.empty')" @retry="_listAuditAuthOwners">
            <el-table-column prop="communityName" :label="$t('auditAuthOwner.communityName')" align="center"
              min-width="130" show-overflow-tooltip />
            <el-table-column :label="$t('auditAuthOwner.owner')" align="center" min-width="130">
              <template slot-scope="scope">
                <div>{{ scope.row.appUserName }}</div>
                <div v-if="scope.row.ownerId" class="ds-cell-sub">{{ scope.row.ownerId }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="link" :label="$t('auditAuthOwner.phone')" align="center" width="120">
              <template slot-scope="scope">
                <span class="ds-num">{{ scope.row.link || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="roomName" :label="$t('auditAuthOwner.room')" align="center" min-width="120">
              <template slot-scope="scope">
                {{ scope.row.roomName || '-' }}
              </template>
            </el-table-column>
            <el-table-column prop="ownerTypeCdName" :label="$t('auditAuthOwner.ownerType')" align="center" width="110">
              <template slot-scope="scope">
                {{ scope.row.ownerTypeCdName || '-' }}
              </template>
            </el-table-column>
            <el-table-column prop="idCard" :label="$t('auditAuthOwner.idCard')" align="center" min-width="150">
              <template slot-scope="scope">
                <span class="ds-num">{{ scope.row.idCard || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="stateName" :label="$t('auditAuthOwner.state')" align="center" width="110">
              <template slot-scope="scope">
                <ds-status-tag :label="scope.row.stateName" :text="scope.row.stateName" type="info" />
              </template>
            </el-table-column>
            <el-table-column prop="remark" :label="$t('auditAuthOwner.remark')" align="center" min-width="150"
              show-overflow-tooltip>
              <template slot-scope="scope">
                {{ scope.row.remark || '-' }}
              </template>
            </el-table-column>
            <el-table-column prop="createTime" :label="$t('auditAuthOwner.createTime')" align="center" width="160">
              <template slot-scope="scope">
                <span class="ds-num">{{ scope.row.createTime || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="appTypeName" :label="$t('auditAuthOwner.appType')" align="center" width="110">
              <template slot-scope="scope">
                {{ scope.row.appTypeName || '-' }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('common.operation')" align="center" width="220" fixed="right">
              <template slot-scope="scope">
                <el-button v-if="scope.row.state == '10000'" size="mini" type="primary"
                  @click="_openAuditAuthOwnerModel(scope.row)">
                  {{ $t('auditAuthOwner.audit') }}
                </el-button>
                <el-button size="mini" type="danger" @click="_deleteAppUserBindingOwnerModel(scope.row)">
                  {{ $t('common.delete') }}
                </el-button>
                <el-button size="mini" type="warning" @click="_resetUserPwdModel(scope.row)">
                  {{ $t('auditAuthOwner.resetPwd') }}
                </el-button>
              </template>
            </el-table-column>
          </ds-data-table>

          <ds-pagination-bar :total="auditAuthOwnerInfo.total" :page="auditAuthOwnerInfo.conditions.page"
            :size="auditAuthOwnerInfo.conditions.row" :page-sizes="[10, 20, 30, 50]"
            @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </el-col>
    </el-row>

    <delete-binding-owner-dialog ref="deleteDialog" @delete-success="_deleteSuccess" />
    <reset-pwd-dialog ref="resetPwdDialog" />
  </div>
</template>

<script>
import { listAuditAppUserBindingOwners } from '@/api/owner/auditAuthOwnerApi'
import { getCommunityId } from '@/api/community/communityApi'
import DeleteBindingOwnerDialog from '@/components/owner/DeleteAppUserBindingOwner'
import ResetPwdDialog from '@/components/owner/ResetStaffPwd'
import DsPageHeader from '@/components/ds/ds-page-header.vue'
import DsSearchPanel from '@/components/ds/ds-search-panel.vue'
import DsToolbar from '@/components/ds/ds-toolbar.vue'
import DsDataTable from '@/components/ds/ds-data-table.vue'
import DsPaginationBar from '@/components/ds/ds-pagination-bar.vue'
import DsStatusTag from '@/components/ds/ds-status-tag.vue'

export default {
  name: 'AuditAuthOwnerList',
  components: {
    DeleteBindingOwnerDialog,
    ResetPwdDialog,
    DsPageHeader,
    DsSearchPanel,
    DsToolbar,
    DsDataTable,
    DsPaginationBar,
    DsStatusTag
  },
  data() {
    return {
      loading: false,
      hasError: false,
      errorMessage: '',
      density: 'default',
      communityId: '',
      auditAuthOwnerInfo: {
        appUsers: [],
        total: 0,
        conditions: {
          page: 1,
          row: 10,
          appUserName: '',
          idCard: '',
          link: '',
          state: '',
          communityId: ''
        },
        states: [
          { name: this.$t('auditAuthOwner.all'), statusCd: '' },
          { name: this.$t('auditAuthOwner.pending'), statusCd: '10000' },
          { name: this.$t('auditAuthOwner.success'), statusCd: '12000' },
          { name: this.$t('auditAuthOwner.failed'), statusCd: '13000' }
        ]
      }
    }
  },
  created() {
    this.communityId = getCommunityId()
    this.auditAuthOwnerInfo.conditions.communityId = this.communityId
    this._listAuditAuthOwners()
  },
  methods: {
    async _listAuditAuthOwners() {
      try {
        this.loading = true
        this.hasError = false
        this.errorMessage = ''
        const params = { ...this.auditAuthOwnerInfo.conditions }

        // 清理参数
        params.appUserName = params.appUserName.trim()
        params.link = params.link.trim()
        params.idCard = params.idCard.trim()

        const res = await listAuditAppUserBindingOwners(params)
        this.auditAuthOwnerInfo.appUsers = res.data
        this.auditAuthOwnerInfo.total = res.total
      } catch (error) {
        console.error('获取数据失败:', error)
        this.hasError = true
        this.errorMessage = this.$t('auditAuthOwner.fetchError')
      } finally {
        this.loading = false
      }
    },
    _openAuditAuthOwnerModel(appUser) {
      this.$router.push({
        path: '/views/owner/auditAuthOwnerUndo',
        query: {
          appUserId: appUser.appUserId,
          roomId: appUser.roomId,
          appUserName: appUser.appUserName,
          link: appUser.link
        }
      })
    },
    _auditSubmit(auditData) {
      console.log(auditData)
    },
    _queryAuditAuthOwnerMethod() {
      this.auditAuthOwnerInfo.conditions.page = 1
      this._listAuditAuthOwners()
    },
    _resetAuditAuthOwnerMethod() {
      this.auditAuthOwnerInfo.conditions = {
        page: 1,
        row: 10,
        appUserName: '',
        idCard: '',
        link: '',
        state: '',
        communityId: this.communityId
      }
      this._listAuditAuthOwners()
    },
    _deleteAppUserBindingOwnerModel(row) {
      this.$refs.deleteDialog.open(row)
    },
    _resetUserPwdModel(staff) {
      this.$refs.resetPwdDialog.open(staff)
    },
    _swatchState(item) {
      this.auditAuthOwnerInfo.conditions.state = item.statusCd
      this._listAuditAuthOwners()
    },
    _deleteSuccess() {
      this._listAuditAuthOwners()
    },
    handleSizeChange(val) {
      this.auditAuthOwnerInfo.conditions.row = val
      this._listAuditAuthOwners()
    },
    handleCurrentChange(val) {
      this.auditAuthOwnerInfo.conditions.page = val
      this._listAuditAuthOwners()
    }
  }
}
</script>

<style lang="scss" scoped>
.audit-auth-owner-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}

/* 表格 + 分页 组成的白色面板 */
.ds-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  overflow: hidden;
}

/* 面板标题 */
.ds-panel__title {
  font-size: var(--ds-font-size-lg);
  font-weight: 600;
  color: var(--ds-gray-800);
}

/* 单元格次要说明 */
.ds-cell-sub {
  font-size: var(--ds-font-size-sm);
  color: var(--ds-gray-500);
}

/* 左侧状态筛选树 */
.ds-status-tree {
  padding: var(--ds-spacing-md) 0;

  &__title {
    padding: 0 var(--ds-spacing-lg) var(--ds-spacing-sm);
    font-size: var(--ds-font-size-sm);
    font-weight: 600;
    color: var(--ds-gray-600);
  }

  &__list {
    padding: 0;
    margin: 0;
    list-style: none;
  }

  &__item {
    padding: 10px var(--ds-spacing-lg);
    font-size: var(--ds-font-size-sm);
    color: var(--ds-gray-700);
    cursor: pointer;
    border-left: 3px solid transparent;
    transition: background-color var(--ds-transition-fast), color var(--ds-transition-fast);

    &:hover {
      background-color: var(--ds-gray-100);
    }

    &.is-active {
      background-color: var(--ds-primary-sub);
      border-left-color: var(--ds-primary);
      color: var(--ds-primary);
      font-weight: 600;
    }
  }
}
</style>
